import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {NgPipesModule} from 'ngx-pipes';
import {ClickOutsideDirective} from './directives/click-outside.directive';
import {PercentageDirective} from './directives/percentage.directive';
import {TabIconAnchorDirective} from './directives/tab-icon-anchor.directive';
import {WagesComponent} from './controllers/wages/wages.component';
import {CustomTableComponent} from './controllers/custom-table/custom-table.component';
import {CriteriaComponent} from './controllers/criteria/criteria.component';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgSelectModule} from '@ng-select/ng-select';
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import {ExpensesComponent} from './controllers/expenses/expenses.component';
import {ClothingRequirementsComponent} from './controllers/clothing-requirements/clothing-requirements.component';
import {DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule} from 'ngx-dropzone-wrapper';
import {FilterComponent} from './controllers/filter/filter.component';
import {NestedDropdownComponent} from './controllers/nested-dropdown/nested-dropdown.component';
import {TranslateSharedModule} from './translateSharedModule';
import {GooglePlaceModule} from 'ng2-google-place-autocomplete/src/app/ng2-google-place.module';
import {TooltipModule} from 'primeng/tooltip';
import {InputMaskModule} from 'primeng/inputmask';
import {RatingModule} from 'primeng/rating';
import {RouterModule} from '@angular/router';
import {LoadTemplateModalModule} from './controllers/load-template-modal/load-template-modal.module';
import {CardTestModule} from './controllers/card/card-test.module';
import {AgencyService, LocationService, UserService} from '../_services';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {CalendarModule} from 'primeng/calendar';
import {AccordionModule} from 'primeng/accordion';
import {SliderModule} from 'primeng/slider';
import {TabViewModule} from 'primeng/tabview';
import {TableModule} from 'primeng/table';
import {ToolbarModule} from 'primeng/toolbar';
import { SalaryClassComponent } from './controllers/salary-class/salary-class.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import {DefaultClientOrderLocationComponent} from './controllers/default-client-order-location/default-client-order-location.component';
import { LocationPopupComponent } from 'app/cms/pages/default/project/basic-information/controllers/location-popup.component';
// JS-1871 (Self Service 4b): shared client Options + Order Approval panel used by settings + profile.
import { ClientSettingsPanelComponent } from './controllers/client-settings-panel/client-settings-panel.component';
// JS-1920 follow-up (2026-11-02): shared user-management surface, mounted on the client
// profile Settings tab (/client/profile/:id). Replaces the inline block that used to live
// on the agency-side client settings page (/agency-client/profile/:id).
import { ClientUserManagementComponent } from './controllers/client-user-management/client-user-management.component';
// JS-1936: shared Working Time Settings matrix — agency profile + client settings panel both mount it.
import { WorkingTimeSettingsComponent } from 'app/cms/pages/default/agency/profile/controllers/working-time-settings/working-time-settings.component';
// JS-1920 (2026-10-20): moved declaration here so the Client Portal Settings panel can mount
// the same clothing requirements component inside a fullscreen dialog. The standalone agency
// route (/agency/edit-clothing-requirements) continues to work by importing SharedModule.
import { EditClothingRequirementsComponent } from 'app/cms/pages/default/agency/edit-clothing-requirements/edit-clothing-requirements.component';


const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    maxFilesize: 50,
    addRemoveLinks: true,
    dictRemoveFile: 'Remove',
};

@NgModule({
    declarations: [
        ClickOutsideDirective,
        WagesComponent,
        ExpensesComponent,
        ClothingRequirementsComponent,
        CriteriaComponent,
        FilterComponent,
        NestedDropdownComponent,
        CustomTableComponent,
        PercentageDirective,
        SalaryClassComponent,
        DefaultClientOrderLocationComponent,
        LocationPopupComponent,
        TabIconAnchorDirective,
        ClientSettingsPanelComponent,
        ClientUserManagementComponent,
        WorkingTimeSettingsComponent,
        EditClothingRequirementsComponent
    ],
    imports: [
        RouterModule,
        NgPipesModule,
        FormsModule,
        CommonModule,
        NgSelectModule,
        DialogModule,
        ConfirmDialogModule,
        ToastModule,
        CalendarModule,
        DropzoneModule,
        AccordionModule,
        SliderModule,
        TranslateSharedModule,
        GooglePlaceModule,
        TooltipModule,
        InputMaskModule,
        RatingModule,
        LoadTemplateModalModule,
        CardTestModule,
        TabViewModule,
        TableModule,
        ToolbarModule,
        InputSwitchModule
    ],
    exports: [
        ClickOutsideDirective,
        WagesComponent,
        ExpensesComponent,
        ClothingRequirementsComponent,
        FilterComponent,
        CriteriaComponent,
        CustomTableComponent,
        PercentageDirective,
        SalaryClassComponent,
        NestedDropdownComponent,
        DefaultClientOrderLocationComponent,
        LocationPopupComponent,
        TabIconAnchorDirective,
        ClientSettingsPanelComponent,
        ClientUserManagementComponent,
        WorkingTimeSettingsComponent,
        EditClothingRequirementsComponent
    ],
    providers: [
        UserService,
        AgencyService,
        LocationService,
        {provide: DROPZONE_CONFIG, useValue: DEFAULT_DROPZONE_CONFIG}
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule {
}
